import {companyFeaturesConstants} from '../../constants';
import {useCompanyFeatureAvailable} from './useCompanyFeatureAvailable';

const featureName = companyFeaturesConstants.EXPENSE_AGENT_AVAILABLE;

/**
 * Checks if the AI expense analysis agent is available for the company.
 *
 * @returns {boolean} True when the `expense_agent_available` company feature is enabled.
 *
 * @example
 * const isExpenseAgentAvailable = useIsExpenseAgentAvailable();
 */
export const useIsExpenseAgentAvailable = () => {
  return useCompanyFeatureAvailable(featureName);
};
